<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row nzGutter="24">
    <nz-divider nzText="Thông tin người khuyết tật" nzOrientation="left" nzPlain></nz-divider>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="studentCode" nzRequired #label>Mã định danh</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Phải chọn người cần chuyển cơ sở">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <input nz-input formControlName="studentCode" name="studentCode" type="text"
              placeholder="Nhập mã người khuyết tật" [jAutofocus] (keyup)="changStudentCode()" maxlength="12">
          </nz-input-group>
          <ng-template #suffixIconButton>
            <button nz-button nzType="primary" nzSearch (click)="PopupChooseStu()"><i nz-icon
                nzType="search"></i></button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="fullName" #label>Họ tên</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="">
          <nz-input-group [nzSuffix]="suffixTemplatefullName">
            <input nz-input [disabled]="true" [(ngModel)]="transferSchool.fullName" placeholder="Họ tên"
              [ngModelOptions]="{standalone: true}" />
          </nz-input-group>
          <ng-template #suffixTemplatefullName><i nz-icon nz-tooltip
              nzTooltipTitle="Họ tên tự động lấy khi chọn người khuyết tật" nzType="info-circle"></i></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="gender" #label>Giới tính</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="">
          <nz-input-group [nzSuffix]="suffixTemplategender">
            <input nz-input [disabled]="true" [(ngModel)]="transferSchool.gender" placeholder="Giới tính"
              [ngModelOptions]="{standalone: true}" />
          </nz-input-group>
          <ng-template #suffixTemplategender><i nz-icon nz-tooltip
              nzTooltipTitle="Giới tính tự động lấy khi chọn người khuyết tật" nzType="info-circle"></i></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="yearOfBirth" #label>Năm sinh</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="">
          <nz-input-group [nzSuffix]="suffixTemplateyearOfBirth">
            <input nz-input [disabled]="true" [(ngModel)]="transferSchool.yearOfBirth" placeholder="Năm sinh"
              [ngModelOptions]="{standalone: true}" />
          </nz-input-group>
          <ng-template #suffixTemplateyearOfBirth><i nz-icon nz-tooltip
              nzTooltipTitle="Năm sinh tự động lấy khi chọn người khuyết tật" nzType="info-circle"></i></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="typeOfDisabilityName" #label>Dạng tật</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="">
          <nz-input-group [nzSuffix]="suffixTemplatetypeOfDisabilityName">
            <input nz-input [disabled]="true" [(ngModel)]="transferSchool.typeOfDisabilityName" placeholder="Dạng tật"
              [ngModelOptions]="{standalone: true}" />
          </nz-input-group>
          <ng-template #suffixTemplatetypeOfDisabilityName><i nz-icon nz-tooltip
              nzTooltipTitle="Dạng tật tự động lấy khi chọn người khuyết tật" nzType="info-circle"></i></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="levelName" #label>Mức độ khuyết tật</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="">
          <nz-input-group [nzSuffix]="suffixTemplatelevelName">
            <input nz-input [disabled]="true" [(ngModel)]="transferSchool.levelName" placeholder="Mức độ khuyết tật"
              [ngModelOptions]="{standalone: true}" />
          </nz-input-group>
          <ng-template #suffixTemplatelevelName><i nz-icon nz-tooltip
              nzTooltipTitle="Mức độ khuyết tật tự động lấy khi chọn người khuyết tật" nzType="info-circle"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <nz-divider nzText="Thông tin cơ sở tiếp nhận" nzOrientation="left" nzPlain></nz-divider>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="provinceId" nzSpan="24" nzRequired>Tỉnh thành</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            formControlName="provinceId" [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="districtId" nzSpan="24" nzRequired>Quận huyện</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="districtControl" (ascModelChange)="changeDistrict($event)"
            formControlName="districtId" [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="transferToEatosId" nzSpan="24" nzRequired>Cơ sở tiếp nhận</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="transferToEatosIdControl" (ascModelChange)="changeTransferToEatos($event)"
            formControlName="transferToEatosId" [placeholder]="'Chọn cơ sở tiếp nhận'"
            [getListAC]="getTransferToEatosACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <nz-divider nzOrientation="left" nzPlain></nz-divider>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzSpan="24" nzFor="transferDate" nzRequired>Ngày chuyển</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
          <nz-date-picker [nzPlaceHolder]="'Chọn ngày chuyển'" formControlName="transferDate" [nzFormat]="dateFormat">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="16">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="transferReason" #label>Lý do</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="transferReason" name="transferReason" type="text" placeholder="Nhập lý do"
            maxlength="550">
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>
